import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { addAlpha } from '@algoan/deep-dive/theme';

interface WhiteboardProps {
  className?: string;
}

export const Whiteboard: React.FC<PropsWithChildren<WhiteboardProps>> = ({ children, className }) => {
  return <S.Container className={className}>{children}</S.Container>;
};

const S = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    flex: 1;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: white;
    border-radius: 5px;
    box-shadow: 0px 1px 10px ${({ theme }) => addAlpha(theme.algoanBlue, 0.05)};
    padding: 30px;

    @media print {
      box-shadow: none;
    }
  `,
};
